import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get sales List
export const getSalesList = createAsyncThunk(
  "getSalesList",
  async (
    {
      search,
      pageLimit,
      pageCount,
      category_id,
      sort_by,
      sort_direction,
      company_name,
      types,
      date_range,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `sales?search=${search}&category_id=${
          category_id ?? ""
        }&page=${pageCount}&limit=${pageLimit}&sort_by=${sort_by}&sort_direction=${sort_direction}&company_name=${company_name}&types=${types}&date_range=${date_range}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// update Sale Status
export const updateSaleStatus = createAsyncThunk(
  "updateSaleStatus",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`sales`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get sales id List
export const getSalesById = createAsyncThunk(
  "getSalesById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`sales/${id}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// update Sale Delete
export const saleDelete = createAsyncThunk(
  "saleDelete",
  async ({ ids }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`delete-sales`, {
        data: { ids: ids },
      });
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// send email
export const sendEmail = createAsyncThunk(
  "sendEmail",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`send-service-report`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// send email
export const sendSales = createAsyncThunk(
  "sendEmail",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`send-mail`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// update Sale Item Prices
export const updateSaleItemPrices = createAsyncThunk(
  "updateSaleItemPrices",
  async (
    { sale_id, service_request_item_details, remarks },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.post(`sales-item-details/${sale_id}`, {
        service_request_item_details,
        remarks: remarks || "",
      });
      toast.success(response.data.message || "Pricing updated successfully");
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message || "Failed to update pricing");
      return rejectWithValue(error.response.data);
    }
  }
);

const salesSlice = createSlice({
  name: "sales",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // Get getSalesList
      .addCase(getSalesList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSalesList.fulfilled, (state, action) => {
        state.loading = false;
        state.getSalesListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getSalesList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Get getSalesById
      .addCase(getSalesById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSalesById.fulfilled, (state, action) => {
        state.loading = false;
        state.getSalesByIdStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getSalesById.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});
const { reducer } = salesSlice;
export default reducer;
